
// Export a toast function that wraps sonner toast 
import { toast as sonnerToast } from "sonner";

export const toast = {
  success: (message: string, title?: string) => {
    sonnerToast.success(title || "Sucesso", {
      description: message,
    });
  },
  error: (message: string, title?: string) => {
    sonnerToast.error(title || "Erro", {
      description: message,
    });
  },
  info: (message: string, title?: string) => {
    sonnerToast.info(title || "Informação", {
      description: message,
    });
  },
  warning: (message: string, title?: string) => {
    sonnerToast.warning(title || "Atenção", {
      description: message,
    });
  },
};
